/*
 * FOC-23 · Botón de compra al elegir una variante que no se vende («Próximamente» o sin stock).
 *
 * Horizon cambia la URL apenas se toca una pill, pero deshabilita el botón recién cuando vuelve la
 * respuesta del servidor (fetch de la sección). En esa ventana el botón seguía diciendo «Agregar al
 * carrito». Horizon igual descarta el agregado (cola + variante no disponible), pero el estado visible
 * era engañoso. Este script deshabilita el botón y pone «Próximamente» en el mismo instante del
 * cambio; después el morph de Horizon lo confirma con el HTML del servidor.
 *
 * Lee data-option-available del valor elegido, que en snippets/variant-main-picker.liquid ya incluye
 * el criterio «Próximamente» (snippets/foc-proximamente.liquid). Si el valor se vende, no toca nada.
 */
(function () {
  'use strict';

  if (window.focComingSoonGuardReady) return;
  window.focComingSoonGuardReady = true;

  var script = document.currentScript;
  var comingSoonText = (script && script.dataset.comingSoonText) || '';

  /** @param {Element} picker */
  function selectedUnavailable(picker) {
    var checked = picker.querySelector('input[type="radio"]:checked');
    if (checked) return checked.getAttribute('data-option-available') === 'false';
    var select = picker.querySelector('select');
    var option = select && select.selectedOptions && select.selectedOptions[0];
    return !!option && option.getAttribute('data-option-available') === 'false';
  }

  /** @param {HTMLButtonElement} button */
  function showComingSoon(button) {
    button.disabled = true;
    if (!comingSoonText) return;
    var icon = button.querySelector('.add-to-cart-icon');
    if (icon) icon.hidden = true;
    for (var i = 0; i < button.childNodes.length; i++) {
      var node = button.childNodes[i];
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '') {
        node.textContent = comingSoonText;
        return;
      }
    }
  }

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      var picker = target.closest('variant-picker');
      if (!picker || !selectedUnavailable(picker)) return;

      // Mismo producto: la sección de la ficha o el modal de agregado rápido.
      var scope = picker.closest('.shopify-section, dialog') || document;
      var buttons = scope.querySelectorAll('product-form-component [ref="addToCartButton"]');
      Array.prototype.forEach.call(buttons, showComingSoon);
    },
    true
  );
})();
